import '../../scss/app.scss';
// import '../../scss/pages/Index.scss';
import '@popperjs/core';
import 'bootstrap/dist/js/bootstrap.bundle.min';
// 要上新的 css 就放在這邊就好了
import React, { Suspense } from 'react';
import { render } from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';

// redux store
import store from '../store';

// component
const CombineFooterContainer = React.lazy(() => import('../containers/Layouts/CombineFooterContainer'));

// 測試首頁
render(
  <Provider store={store}>
    <BrowserRouter>
        <Suspense fallback={<div />}>
            <CombineFooterContainer />
        </Suspense>
    </BrowserRouter>
  </Provider>,
  document.getElementById('combineFooterEntry'),
);
